var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'customize-button',
    `customize-button-${_vm.size}`,
    `customize-button-${_vm.size}-${_vm.type}`,
  ],style:(_vm.btnStyle),attrs:{"disabled":_vm.loading,"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('span',[_c('i',{staticClass:"el-icon-loading"}),_vm._v(" loading ")]):_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }